import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.trackKey = this.data.get("trackKey")
    this.runningTask = this.data.get("runningTask") === "true"
    this.buttonDisabled = false

    if (this.runningTask) {
      this.checkStatus()
      this.markAsRunning()
    }
  }

  checkStatus() {
    let ctrl = this

    $.get(`/tracks/${this.trackKey}/check_now_status`).done(function(data) {
      if (data === "Finished") {
        setTimeout(function() {
          Turbolinks.visit(window.location)
        }, 1000)
      } else {
        setTimeout(function() {
          ctrl.checkStatus()
        }, 1000)
      }
    })
  }

  markAsRunning() {
    this.buttonDisabled = true

    let button = $(this.element)
    button.find(".fa-spinner.hidden").removeClass("hidden")
    button.addClass("disabled")
  }

  schedule() {
    let ctrl = this
    if (this.buttonDisabled) { return }

    ctrl.markAsRunning()

    $.post(`/tracks/${this.trackKey}/check_now`).done(function() {
      ctrl.checkStatus()
    }).fail(function() {
      alert("Something went wrong.")
      Turbolinks.visit(window.location)
    })
  }
}
